module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/twins-left-bg.fed090fb.png";